{
  "level": "dbmov",
  "source": {
    "spawn": "DERIVED_FROM_TREES_BBOX:dbmov",
    "objects": "AREAS.E3:dbmov.e3",
    "mesh": "TREES.E3:dbmov.e3"
  },
  "spawn_point": {
    "position": [
      0.0,
      0.0,
      0.0
    ],
    "facing_rad": 0.0,
    "look_point": [
      0.0,
      100.0,
      0.0
    ],
    "forward": [
      0.0,
      1.0,
      0.0
    ],
    "up": [
      0.0,
      0.0,
      1.0
    ],
    "derived": true
  },
  "mesh_point_cloud": {
    "note": "Raw vertex positions from TREES.E3.",
    "bbox_min": [
      0.0,
      0.0,
      0.0
    ],
    "bbox_max": [
      0.0,
      0.0,
      0.0
    ],
    "vertex_count": 0,
    "vertices": []
  },
  "sectors": [
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3088.89990234375,
      "bbox_min": [
        -3088.89990234375,
        -5131.0,
        1105.0
      ],
      "bbox_max": [
        -3088.89990234375,
        -5127.0,
        1107.5999755859375
      ],
      "face_count": 1
    }
  ],
  "placed_objects": [
    {
      "tag": "CSlidingDoor piece: elvdor1a",
      "entity_class": "CSlidingDoor",
      "piece_name": "elvdor1a",
      "offset": 431,
      "centroid": [
        -2979.500244140625,
        -5154.5,
        1108.2999877929688
      ],
      "bbox_min": [
        -2980.000244140625,
        -5159.0,
        1101.5999755859375
      ],
      "bbox_max": [
        -2979.000244140625,
        -5150.0,
        1115.0
      ],
      "dimensions_source": {
        "span_x": 1.0,
        "span_y": 9.0,
        "height_z": 13.4000244140625,
        "door_width": 9.0,
        "door_depth": 1.0,
        "leaf_depth": 0.96,
        "clearance_margin": 0.02,
        "slide_axis": "z",
        "slide_vector": [
          0.0,
          0.0,
          -1.0
        ]
      },
      "vertices": [
        [
          -2980.000244140625,
          -5159.0,
          1101.5999755859375
        ],
        [
          -2980.000244140625,
          -5159.0,
          1115.0
        ],
        [
          -2980.000244140625,
          -5150.0,
          1115.0
        ],
        [
          -2980.000244140625,
          -5150.0,
          1101.5999755859375
        ],
        [
          -2979.000244140625,
          -5159.0,
          1115.0
        ],
        [
          -2979.000244140625,
          -5159.0,
          1101.5999755859375
        ],
        [
          -2979.000244140625,
          -5150.0,
          1101.5999755859375
        ],
        [
          -2979.000244140625,
          -5150.0,
          1115.0
        ]
      ],
      "plane_distance": 1101.6,
      "authentic_texture": "cbaseelevdoor"
    },
    {
      "tag": "CSlidingDoor piece: elvdor1b",
      "entity_class": "CSlidingDoor",
      "piece_name": "elvdor1b",
      "offset": 1581,
      "centroid": [
        -2979.500244140625,
        -5154.5,
        984.9999389648438
      ],
      "bbox_min": [
        -2980.000244140625,
        -5159.0,
        979.9999389648438
      ],
      "bbox_max": [
        -2979.000244140625,
        -5150.0,
        989.9999389648438
      ],
      "dimensions_source": {
        "span_x": 1.0,
        "span_y": 9.0,
        "height_z": 10.0,
        "door_width": 9.0,
        "door_depth": 1.0,
        "leaf_depth": 0.96,
        "clearance_margin": 0.02,
        "slide_axis": "z",
        "slide_vector": [
          0.0,
          0.0,
          -1.0
        ]
      },
      "vertices": [
        [
          -2980.000244140625,
          -5159.0,
          979.9999389648438
        ],
        [
          -2980.000244140625,
          -5159.0,
          989.9999389648438
        ],
        [
          -2980.000244140625,
          -5150.0,
          989.9999389648438
        ],
        [
          -2980.000244140625,
          -5150.0,
          979.9999389648438
        ],
        [
          -2979.000244140625,
          -5159.0,
          989.9999389648438
        ],
        [
          -2979.000244140625,
          -5159.0,
          979.9999389648438
        ],
        [
          -2979.000244140625,
          -5150.0,
          979.9999389648438
        ],
        [
          -2979.000244140625,
          -5150.0,
          989.9999389648438
        ]
      ],
      "plane_distance": 979.9999,
      "authentic_texture": "cbaseelevdoor"
    }
  ],
  "tutorial_messages": []
}